module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ce5820b006d753e4133f46ae776f4d96.svg";